// extracted by mini-css-extract-plugin
export default {"fullWidth":"_p-z","image":"aq-z","lazyLoadPicture":"bq-z","lazyLoadSpinner":"cq-z","lazyLoadSpin":"dq-z","lazyLoadImage":"eq-z","hasStyledAspectRatio":"fq-z"};